<template>
    <span class="small-tooltip">
        <slot />
        <span class="small-tooltip__content" role="tooltip">{{ text }}</span>
    </span>
</template>

<script setup lang="ts">
defineProps<{
    text: string
}>()
</script>

<style scoped>
.small-tooltip {
    position: relative;
    display: flex;
    align-items: center;
}

.small-tooltip__content {
    position: absolute;
    top: calc(100% + 6px);
    left: 50%;
    z-index: 60;
    padding: 4px 8px;
    border: 1px solid rgb(255 255 255 / 0.58);
    border-radius: 6px;
    background: rgb(255 255 255 / 0.6);
    color: rgb(34 34 34);
    font-family: Manrope, sans-serif;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 4px 12px oklch(0% 0 0 / 0.1);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    opacity: 0;
    transform: translate(-50%, -2px);
    transition: opacity 150ms ease, transform 150ms ease;
}

.small-tooltip:hover .small-tooltip__content,
.small-tooltip:focus-within .small-tooltip__content {
    opacity: 1;
    transform: translate(-50%, 0);
}
</style>
